import { PlayerProfile } from "@/multiplayer";
import { createContext } from "react";

export const AuthContext = createContext<{
	loggedIn: boolean;
	playerProfile: PlayerProfile;
}>(undefined!);
